"use client"

import styled, { css } from "styled-components"

import { Paragraph } from "@/components/Paragraph"

export const Tag = styled.div`
  ${({ theme, $variant }) => {
    const { spaces, borders, colors } = theme
    const { xs, xxs } = spaces
    const { radius } = borders
    const { fg, bg } = colors[$variant]

    return css`
      display: flex;
      align-items: center;
      gap: ${xs};
      color: ${fg};
      background-color: ${bg};
      border-radius: ${radius.extraSmall};
      padding: ${xxs};
      width: fit-content;
      height: fit-content;
      white-space: nowrap;
    `
  }}
`

export const Text = styled(Paragraph)`
  ${({ theme, $variant }) => {
    const { fg } = theme.colors[$variant]
    const { lineHeight, weight } = theme.fonts
    return css`
      color: ${fg};
      line-height: ${lineHeight.single};
      font-weight: ${weight.normal};
    `
  }}
`
